import { render, staticRenderFns } from "./ActivitySubmission.vue?vue&type=template&id=60b53d52"
import script from "./ActivitySubmission.vue?vue&type=script&lang=js"
export * from "./ActivitySubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports